import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import AlertWidget from '../../../widgets/AlertMsg';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allEntVistasAction,
  setActivoEntVistasAction,
} from './EntVistasAction';
import FormEntVistas from './components/FormEntVistas';
import ListadoEntVistas from './components/ListadoEntVistas';

const EntVistasView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entVistasStore = Redux.useSelector((state) => state.entVistas);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <AlertWidget alert={entVistasStore.alertView} />
      <Grid item md={12}>
        {loginStore.isRoot ? (
          <BotonComponent
            click={async () => {
              await setActivoEntVistasAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            addIcon
            text="ASIGNAR"
            mr={2}
            ml={2}
          />
        ) : null}
        <BotonComponent
          click={async () => {
            await setActivoEntVistasAction(dispatch, null);
            await allEntVistasAction({ dispatch }, entVistasStore.params);
          }}
          disabled={
            entVistasStore.all.length === 0 && entVistasStore.loadingAll
          }
          white
          refreshIcon
          text={entVistasStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <ListadoEntVistas
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormEntVistas"
        title={
          entVistasStore.activo
            ? `Editar ${entVistasStore.activo.vista.nombre}`
            : 'Asignar vista a entidad'
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormEntVistas
          activo={entVistasStore.activo}
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </ModalComponent>
    </Grid>
  );
};

export default EntVistasView;
